import { action } from 'typesafe-actions'
import { Constants } from './constants'
import { TAccount } from 'types'
import { LinkdropP2P, ClaimLink } from 'linkdrop-p2p-sdk'

export function setAddress(address: string) {
  return action(
    Constants.USER_SET_ADDRESS,
    // payload
    {
      address
    }
  )
}


export function setEthPrice (price: string) {
  return action(Constants.USER_SET_ETH_PRICE, { ethPrice: price })
}

export function setMaticPrice (price: string) {
  return action(Constants.USER_SET_MATIC_PRICE, { maticPrice: price })
}

export function setLoading(loading: boolean) {
  return action(
    Constants.USER_SET_LOADING,
    // payload
    {
      loading
    }
  )
}

export function setSigner(signer: any) {
  return action(
    Constants.USER_SET_SIGNER,
    // payload
    {
      signer
    }
  )
}

export function setProvider(provider: any) {
  return action(
    Constants.USER_SET_PROVIDER,
    // payload
    {
      provider
    }
  )
}

export function setChainId(chainId: number) {
  return action(
    Constants.USER_SET_CHAIN_ID,
    // payload
    {
      chainId
    }
  )
}

export function setSDK(sdk: LinkdropP2P) {
  return action(
    Constants.USER_SET_SDK,
    // payload
    {
      sdk
    }
  )
}

export function setClaimLink(claimLink: ClaimLink) {
  return action(
    Constants.USER_SET_CLAIM_LINK,
    {
      claimLink
    }
  )
}

export function setInitialized(initialized: boolean) {
  return action(
    Constants.USER_SET_INITIALIZED,
    // payload
    {
      initialized
    }
  )
}

export function setHasConnector(hasConnector: boolean) {
  return action(
    Constants.USER_SET_HAS_CONNECTOR,
    // payload
    {
      hasConnector
    }
  )
}

export function setUserProvider(userProvider: any) {
  return action(
    Constants.USER_SET_USER_PROVIDER,
    // payload
    {
      userProvider
    }
  )
}


export function setAccount (account: TAccount) {
  return action(
    Constants.USER_SET_ACCOUNT,
    // payload
    {
      account
    }
  )
}

